var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-bottom":"10px"}},[_c('big-one',{attrs:{"content":_vm.content,"type":_vm.type,"objects":_vm.objects}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }